import Axios from "../apis/axios";
import axios, { AxiosResponse } from "axios";
import {
  saveRefreshTokenInfo,
  saveAccessTokenInfo,
  clearAccessTokenInfo,
  clearRefreshTokenInfo,
} from "../data/user";
import _ from "lodash";
import { produce } from "immer";
import i18n from "i18n/i18n";
import { useBoundStore } from "./store";
import { base_url } from "../constants";


export const createUserSlice = (set: (data: any) => void, get: () => any) => ({
  isLoggedIn: false,
  isAdmin: false,
  userNodeId: "",
  legalEntityNodeId: "",
  accessToken: "",
  refreshToken: "",
  isAuthUser: false,
  loginError: "",
  autoLogout: true,
  user: {},
  profiles: [],
  userInfo: {},
  lang: "de",
  loginLoader: false,
  resetPasswordLoader: false,
  users: [],
  acl_users: [],
  clientId: "",
  clientInfoObj: {},
  rabbitmqConfig: {},
  smtpResponse: "",
  //profile: {},

  setIsLoggedIn: (loggedIn: boolean) => {},

  setLang: (lang: string) => {
    set({ lang: lang });
  },

  setLoginError: (err: string) => {
    set({ loginError: err });
  },

  loginUser: async (email: string, password: string) => {
    const body = {
      email: email.toLowerCase(),
      password: password,
    };
    try {
      set({
        loginLoader: true,
      });
      if (true) {
        // Assuming Axios is properly configured and imported
        const response = await Axios.post("api/v1/auth/login", body, {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        });
        if (response && response.status && response?.status === 200) {
          const data = response.data; // Move data declaration here
          if (data.statusCode === 401) {
            let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE
            set({
              isLoggedIn: false,
              loginLoader: false,
              loginError: i18n(lang)?.invalid_creds,
            });
            return false;
          } else {
            if (data.accesstoken) {
              saveAccessTokenInfo(data.accesstoken);
              saveRefreshTokenInfo(data.refreshtoken);

              localStorage.setItem("clientid", data.clientid);

              localStorage.setItem("tabsOpen", "1");

              set({
                isAdmin: data.userinfo.profileid === "admin",
                accessToken: data.accesstoken,
                refreshToken: data.refreshtoken,
                userNodeId: data.usernodeid,
                legalEntityNodeId: data.legalentitynodeid,
                isLoggedIn: true,
                isAuthUser: true,
                loginError: "",
                userInfo: data.userinfo,
                profiles: data.profiles,
                lang: data.userinfo.lang,
                loginLoader: false,
                clientId: data.clientid,
                clientInfoObj: data.clientInfoObj,
                autoLogout: true,
                rabbitmqConfig: data.rabbitmqConfig,
              });
              localStorage.setItem("lang", data.userinfo.lang);

              get().loadTopology(get().lang);
              get().connectWebMQTT();

              return true;
            } else {
              set({
                isLoggedIn: false,
                isAuthUser: false,
                loginLoader: false,
              });
              return false;
            }
          }
        } else {
          set({
            loginLoader: false,

            isLoggedIn: false,
            isAuthUser: false,
          });
          return false;
        }
      }
    } catch (error) {
      set({
        loginLoader: false,

        isLoggedIn: false,
        isAuthUser: false,
      });
    }
  },

  resetPasswordUser: async (email: string) => {
    const body = {
      email: email.toLowerCase(),
    };
    try {
      set({
        resetPasswordLoader: true,
      });
      if (true) {
        // Assuming Axios is properly configured and imported
        const response = await axios.post(base_url+
          "api/v1/users/reset-password/"+encodeURIComponent(email) ,
         {},
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );
         
          set({
            resetPasswordLoader: false,
          });
          return response;
        
      }
    } catch (error) {
      set({
        resetPasswordLoader: false,
      });
      return error;
    }
  },

  isEmptyObject: (obj: Record<string, any>) => {
    return Object.keys(obj).length === 0;
  },

  getUser: async (userNodeId: string, getNew = false) => {
    try {
      if (get().isLoggedIn === true) {
        const encodedUserNodeId = encodeURIComponent(userNodeId);
        const response = await Axios.get(`api/v1/users/${encodedUserNodeId}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (
          response &&
          Object.keys(response).length &&
          response.status &&
          response?.status === 200
        ) {
          set(
            produce((state: any) => {
              state.user = response.data.user;
            })
          );
          return response.data.user;
        } else {
        }
      } else {
        return get().user;
      }
    } catch (error) {}
  },

  createUser: async (payload: any) => {
    try {
      if (get().isLoggedIn === true) {
        const response = await Axios.post(`api/v1/users`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        });

        if (
          response &&
          Object.keys(response).length &&
          response.status &&
          response?.status === 200
        ) {
          return response.data.user;
        } else {
          throw new Error("Failed to fetch user data");
        }
      } else {
        return get().user;
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  updateUser: async (payload: Record<string, any>) => {
    if (!payload) {
      payload = {};
    }

    if (!payload.image) {
      payload.image = {};
    }

    const commandObjects = [];
    let promises: Promise<any>[] | undefined;

    // there is no command in the queue yet
    // so create one

    const updatedCommandObject: any = {
      payload: payload,
      type: "update",
      task: "processUpdateUser",
      // Add other properties of the command object if needed
    };
    commandObjects.push(updatedCommandObject);

    promises = get().enqueueCommands(commandObjects);

    return promises;
  },

  processUpdateUser: async (commandObject: Record<string, any>) => {
    try {
      if (get().isLoggedIn === true) {
        const encodedUserNodeId = encodeURIComponent(
          commandObject.payload.userNodeId
        );
        const response = await Axios.put(
          `/api/v1/users/${encodedUserNodeId}`,
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );
        if (response && response.status && response?.status === 200) {
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  deleteUser: async (payload: Record<string, any>) => {
    const commandObjects = [];
    let promises: Promise<any>[] | undefined;

    const updatedCommandObject: any = {
      payload: payload,
      type: "update",
      task: "processDeleteUser",
    };
    commandObjects.push(updatedCommandObject);

    promises = get().enqueueCommands(commandObjects);

    return promises;
  },

  processDeleteUser: async (commandObject: any) => {
    try {
      if (get().isLoggedIn === true) {
        const encodedUserNodeId = encodeURIComponent(commandObject.payload);
        const response = await Axios.delete(
          `/api/v1/users/${encodedUserNodeId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );
        if (response && response.status && response?.status === 200) {
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  getAllAclUsers: async () => {
    try {
      if (get().isLoggedIn === true) {
        const clientId: any = localStorage.getItem("clientid");
        const response = await Axios.get(`api/v1/users/acl/` + clientId, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (
          response &&
          Object.keys(response).length &&
          response.status &&
          response?.status === 200
        ) {
          set(
            produce((state: any) => {
              state.acl_users = response.data;
            })
          );
          return response.data;
        } else {
          throw new Error("Failed to fetch user data");
        }
      } else {
        return get().user;
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  setPassword: async (data: any, getNew = false) => {
    try {
      const response = await Axios.post(`/api/v1/users/set-password`, data, {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000,
      });
      if (response && response.status && response?.status === 200) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },
  sendResetPasswordLink: async (email: any, getNew = false) => {
    try {
      const response = await Axios.post(
        `/api/v1/users/reset-password/` + email,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );
      if (response && response.status && response?.status === 200) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  getAllUsers: async (
    legalentity: string,
    userNodeId: string,
    getNew = false
  ) => {
    try {
      if (get().isLoggedIn === true) {
        const encodedUserNodeId = legalentity;
        const response = await Axios.get(
          `api/v1/users?legalentitynodeid=` + encodedUserNodeId,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (
          response &&
          Object.keys(response).length &&
          response.status &&
          response?.status === 200
        ) {
          set(
            produce((state: any) => {
              state.users = response.data[0].legalentity.hasmember.filter(
                (member: any) => member.user.nodeid !== userNodeId
              );
            })
          );
          return response.data;
        } else {
          throw new Error("Failed to fetch user data");
        }
      } else {
        return get().user;
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  refreshAccessToken: async (refreshToken: string): Promise<AxiosResponse> => {
    const body = {
      token: refreshToken,
    };

    try {
      const response = await Axios.post<any>(
        "api/v1/object/refresh-token",
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response.status && response?.status === 200) {
        const data: any = response.data;
        saveAccessTokenInfo(data.accesstoken);
        saveRefreshTokenInfo(data.refreshtoken);
        return response;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  updateUserProfile: async (payload: Record<string, any>) => {
    if (!payload) {
      payload = {};
    }

    if (!payload.image) {
      payload.image = {};
    }

    const commandObjects = [];
    let promises: Promise<any>[] | undefined;

    const updatedCommandObject: any = {
      parentNodeIds: [payload.userNodeId],

      nodeId: payload.userNodeId,
      payload: payload,
      type: "update",
      task: "processUpdateUserProfile",
      // Add other properties of the command object if needed
    };
    commandObjects.push(updatedCommandObject);

    promises = get().enqueueCommands(commandObjects);

    return promises;
  },

  processUpdateUserProfile: async (commandObject: Record<string, any>) => {
    try {
      if (get().isLoggedIn === true) {
        const encodedUserNodeId = encodeURIComponent(get().userNodeId);
        const response = await Axios.put(
          `/api/v1/users/${encodedUserNodeId}`,
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );
        if (response && response.status && response?.status === 200) {
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  canUserPerformAction: (feature: string, action: string): boolean => {
    const userRights = get().profile?.features?.[feature];

    if (userRights !== undefined) {
      switch (action) {
        case "create":
          return userRights[0] === 1;
        case "read":
          return userRights[1] === 1;
        case "update":
          return userRights[2] === 1;
        case "delete":
          return userRights[3] === 1;
        default:
          return false;
      }
    } else {
      return false;
    }
  },
  logOut: async () => {
    clearAccessTokenInfo();
    clearRefreshTokenInfo();
    useBoundStore.persist.clearStorage();

    set({
      isLoggedIn: false,
      isAdmin: false,
      userNodeId: "",
      legalEntityNodeId: "",
      accessToken: "",
      refreshToken: "",
      isAuthUser: false,
      loginError: "",
      autoLogout: false,
      user: {},
      profiles: [],
      userInfo: {},
      lang: undefined,
      loginLoader: false,
      subscribedAreas: {},
      subscribedEquipments: {},
      _subscribedEquipments: {}, // for Dashboard Table ( event messages)
      subscribedSites: {},
      eventsTimeRange: false,
      startTime: 0,
      endTime: 0,
    });

    get().disConnectWebMQTT();
  },
  testSMTP: async (payload: Record<string, any>) => {
    if (get().isLoggedIn === true) {
      const response: any = await Axios.post(
        `/api/v1/email/smtptest`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );
      if (response && response.status && response?.status === 200) {
        set(
          produce((state: any) => {
            state.smtpResponse = response;
          })
        );
        return response;
      } else {
        throw new Error();
      }
    }
  },
  updateEmailConfig: async (payload: Record<string, any>) => {
    if (get().isLoggedIn === true) {
      const response: any = await Axios.post(
        `/api/v1/email/updateconfig`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );
      if (response && response.status && response?.status === 201) {
        set(
          produce((state: any) => {
            state.clientInfoObj = response.data && response.data.clientinfo;
          })
        );
        return response;
      } else {
        throw new Error();
      }
    }
  },
});
